import { get } from '../utils/PolyfillLodash'
import executeHookLogic from '../actions/executeHookLogic'
import { CategoryHelper } from './CategoryHelper'
import config from '../config'

const insertAtPosition = (products, index, product) => [...products.slice(0, index), product, ...products.slice(index)]

const insertProducts = (products, hookLogicProducts, insertionIndexes) => {
  hookLogicProducts.map(product => (product.attributes.relevancyRank = 1))
  return insertionIndexes.reduce((products, position, index) => {
    return insertAtPosition(products, position, hookLogicProducts[index])
  }, products)
}

class HookLogicHelper {
  // method does not resolve duplication of products
  static mergeProducts(products, hookLogicProducts) {
    let insertionIndexes = []
    const adProductCount = get(hookLogicProducts, 'length')
    const naturalProductCount = products && products.length

    if (products === null) {
      return null
    }

    // Mobile ads
    if (this.isProdListMobileTabletValid(hookLogicProducts)) {
      if (naturalProductCount >= 2) {
        // If we have more than 2 natural product results, allow ads
        insertionIndexes.push(3) // Add the first ad at the 3rd spot
        if (adProductCount === 2) {
          // If we have two ads
          if (naturalProductCount >= 18) {
            // If we have 18 or more natural product results
            insertionIndexes.push(19) // add the ad the at 19 spot
          } else {
            insertionIndexes.push(naturalProductCount + 1) // else, if we have less - add it as the last product
          }
        }
      }
      return insertProducts(products, hookLogicProducts, insertionIndexes)
    }

    // Desktop ads
    if (naturalProductCount >= 3 && this.isProdListDesktopValid(hookLogicProducts)) {
      insertionIndexes = [3, 4, 5]
      return insertProducts(products, hookLogicProducts, insertionIndexes)
    }

    return products
  }

  static hookLogicCategoryProductHandler(pageType, context, categoryResponse, productResponse) {
    const { initialRenderComplete } = context.reduxStore.getState().application
    if (initialRenderComplete && productResponse && productResponse.status === config.httpStatusCodes.success) {
      const categoryType = get(categoryResponse, 'response.data[0].type')
      const categoryTree = CategoryHelper.flattenAncestors(categoryResponse.response)
      executeHookLogic(context, {
        keyword: '',
        appliedFilters: get(productResponse, 'response.meta.appliedFilters'),
        appliedSorts: get(productResponse, 'response.meta.appliedSorts'),
        currentPage: get(productResponse, 'response.meta.currentPage'),
        categoryTree,
        currentCategory: {
          id: get(categoryResponse, 'response.data[0].id'),
          name: get(categoryResponse, 'response.data[0].attributes.name')
        },
        isPlp: categoryType === 'PLP' || categoryType === 'PLPPLUS',
        pageType
      })
    }
  }

  static getHookLogicProducts(pageType, context, searchTerm, productResponse, categoryResponse) {
    const { initialRenderComplete } = context.reduxStore.getState().application
    let categoryTree = null
    if (categoryResponse !== undefined) {
      if (categoryResponse.response && categoryResponse.response.data) {
        categoryTree = get(categoryResponse, 'response.data')
      } else {
        categoryTree = get(categoryResponse, 'response.included')
      }
    }
    if (initialRenderComplete && productResponse && productResponse.status === config.httpStatusCodes.success) {
      executeHookLogic(context, {
        keyword: searchTerm,
        appliedFilters: get(productResponse, 'response.meta.appliedFilters'),
        appliedSorts: get(productResponse, 'response.meta.appliedSorts'),
        currentPage: get(productResponse, 'response.meta.currentPage'),
        categoryTree,
        pageType
      })
    }
  }

  static isProdListDesktopValid(prodList) {
    return get(prodList, 'length') === 3
  }

  static isProdListMobileTabletValid(prodList) {
    return get(prodList, 'length') === 2 || get(prodList, 'length') === 1
  }
}

export default HookLogicHelper
